export { default } from './StockReceiptInsert';
